import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'

const StyledImageLinkWrapper = styled.div``

const StyledImageWrapper = styled.a`
  align-items: center;
  display: flex;
  flex-direction: column;
`

const StyledText = styled.span`
  color: ${({ theme }) => theme.colors.darkBlue};
  margin: 8px 0 0;

  &:hover,
  &:active,
  &:focus {
    text-decoration: underline;
  }
`

const ImageLink = ({ cmsData }) => {
  const {
    fields: { file, title },
  } = cmsData.image
  return (
    <StyledImageLinkWrapper>
      <StyledImageWrapper href={cmsData.link} alt={cmsData.linkText}>
        <img src={file.url} title={title} loading="lazy" alt={title || ''} />
        <StyledText>Learn More</StyledText>
      </StyledImageWrapper>
    </StyledImageLinkWrapper>
  )
}

ImageLink.propTypes = {
  cmsData: PropTypes.object.isRequired,
}

export default ImageLink
